// react-bootstrap imports
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Spinner, Table } from "react-bootstrap"

// service imports
import { PegarTodosFuncionarios } from "services/CallAPIs"
import { userHasAccess, userLogado } from "services/LoginFunctions"

// constant imports
import { ROLE } from "constants/userRoles"
import * as Links from "constants/links"

function getRoles(funci)
{
    const dictPerm =
    {
        ROLE_ANALISTA: "analista",
        ROLE_USER: "usuário",
        ROLE_TESTER: "testador",
        ROLE_GESTOR: "gestor",
        ROLE_ADMIN: "administrador"
    }
    let roles = funci.roles.map(role => role.name).map(p => p = Object.keys(dictPerm).includes(p) ? dictPerm[p] + ", " : p)
    roles[roles.length - 1] = roles[roles.length - 1].replace(", ", "")

    return roles
}

const TabelaFuncis = ({ funcis }) =>
{
    return (
        <Table hover>
            <thead>
                <tr>
                    <th>Nome</th>
                    <th>Matrícula</th>
                    <th>Cargo</th>
                    <th>Permissões</th>
                </tr>
            </thead>
            <tbody>
                {funcis.map(funci => <tr key={funci.nome}><td>{funci.nome}</td><td>{funci.matricula}</td><td>{funci.cargo}</td><td>{getRoles(funci)}</td></tr>)}
            </tbody>
        </Table>
    )
}

export const VerFuncionariosScreen = () =>
    {
        const navigate = useNavigate()
        const [loading, setLoading] = useState(true)
        const [funcis, setFuncis] = useState(null)
    
        useEffect(() => {
            if(funcis != null)
            {
                setLoading(false)
            }
        }, [funcis])

        useEffect(() => {
            async function fetchFuncis()
            {
                const funcis = await PegarTodosFuncionarios()
                setFuncis(funcis)
            }
            fetchFuncis()
        }, [loading])

        if (!userLogado) { navigate(Links.SEM_PERMISSAO) }
        if (!userHasAccess(ROLE.GESTOR)) { navigate(Links.SEM_PERMISSAO) }
    
        return (
            <div className="container align-items-center bg-white border border-dark rounded-4 p-2 mb-3 shadow">
                <div className="d-flex flex-column align-items-center">
                <p className = "fw-bold mt-3 align-self-center">Funcionários cadastrados</p>
                    {
                    loading?
                    <div className = "d-flex flex-column align-items-center my-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                    :
                    <TabelaFuncis funcis={funcis}  />
                    }
                </div>
            </div>
        )
    }